/**
 * Used to filter out Transcycle specific custom fields
 * that should be rendered under the location tab
 * */
export const LOCATION_KEYS = ['cluster', 'branch_region', 'branch_area', 'branch_name'];
